import React, { useEffect, useState } from 'react';
import Base from '../core/Base';
import { getUser } from '../apiCallsHelper/userapicalls';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import AccountUpdate from './AccountUpdate';
import ChangePassword from './ChangePassword';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faLock } from '@fortawesome/free-solid-svg-icons';



const AccountSettings = () => {

  const { user, token } = isAuthenticated();

  const [isCancel, setIsCancel] = useState(false);
  const [isDisableFirstname, setIsDisableFirstname] = useState(true);
  const [isDisableLastname, setIsDisableLastname] = useState(true);
  const [isDisableEmail, setIsDisableEmail] = useState(true);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [activeTab, setActiveTab] = useState("Account settings");


  const [userDetails, setUserDetails] = useState({
    fname: "",
    lname: "",
    email: "",
  });



  const sidebarTabs = [
    {
      name: "Account settings",
      faIcon: <FontAwesomeIcon icon={faKey} />
    },
    {
      name: "Change password",
      faIcon: <FontAwesomeIcon icon={faLock} />
    },
  ]




  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserDetails((prevData) => ({ ...prevData, [name]: value }));
  }

  const handleEditFirstname = () => {
    setIsDisableFirstname(false);
  }

  const handleSaveFirstname = () => {
    setIsDisableFirstname(true);
  }

  const handleEditLastname = () => {
    setIsDisableLastname(false);
  }

  const handleSaveLastname = () => {
    setIsDisableLastname(true);
  }

  const handleEditEmail = () => {
    setIsDisableEmail(false);
  }

  const handleSaveEmail = () => {
    setIsDisableEmail(true);
  }


  const fetchUser = () => {
    getUser(user._id, token)
      .then(data => {
        if (data.error) {
          toast.error(data.error);
          // console.log("data.error in account settings: ", data.error)
        }
        else {
          setUserDetails(data)
          toast.success(data.message);
          // console.log("data in account settings: ", data)
        }
      })
  }


  const handleChangeTab = (tabName) => {
    if (tabName === activeTab) {
      return;
    }
    setActiveTab(tabName);
    // console.log("tabName: ", tabName)
    // console.log("activeTab: ", activeTab)
  }





  useEffect(() => {
    fetchUser();
    if (isCancel) {
      setIsCancel(false);
    }
  }, [isCancel])





  return (
    <>

      <Base>

        <div className='h-screen'>

          <div className='h-[500px] w-[280px] mt-6   xs:h-[500px] xs:w-[360px] xs:mt-8    mobSm:h-[500px] mobSm:w-[410px] mobSm:mt-8      sm:h-[550px] sm:w-[480px] sm:mt-14    mobLg:h-[500px] mobLg:w-[600px] mobLg:mt-14      md:h-[500px] md:w-[750px] md:mt-10    smLaptop:h-[500px] smLaptop:w-[820px] smLaptop:mt-4     lg:h-[500px] lg:w-[900px]      xl:h-[500px] xl:w-[900px]       relative  mt-4 container mx-auto border border-[#c1cae3] rounded shadow-xl shadow-[#c1cae3]'>
            <div className='w-[90px]    xs:w-[130px]    mobSm:w-[160px]       sm:w-[160px]  mobLg:w-[200px]  md:w-[230px]      smLaptop:w-[230px]      lg:w-[230px]       xl:w-[230px]        absolute inset-y-0 left-0 bg-[#c1cae3] border border-[#c1cae3]'>

              <div>
                {sidebarTabs.map((tabItem, index) => {
                  const { name, faIcon } = tabItem;
                  return (
                    <li key={index} onClick={() => handleChangeTab(name)} className={`list-none cursor-pointer text-center  font-bold py-4 hover:bg-[#8a9dd4] hover:text-white  ${name === activeTab ? 'bg-[#6d7fb0] text-white' : 'bg-[#c1cae3] text-blue-900'} `}>
                      {faIcon ? faIcon : ""} {name}
                    </li>)
                })}
              </div>
            </div>


            <div className='w-[190px]    xs:w-[230px]   mobSm:w-[250px]   sm:w-[320px]  mobLg:w-[400px]  md:w-[520px]      smLaptop:w-[590px]      lg:w-[670px]       xl:w-[670px]  absolute inset-y-0 right-0  border border-[#b6cafc]'>
              {activeTab === "Account settings" ? (
                <AccountUpdate userDetails={userDetails}
                  handleInputChange={handleInputChange}
                  isDisableFirstname={isDisableFirstname}
                  handleSaveFirstname={handleSaveFirstname}
                  handleEditFirstname={handleEditFirstname}
                  isDisableLastname={isDisableLastname}
                  handleSaveLastname={handleSaveLastname}
                  handleEditLastname={handleEditLastname}
                  isDisableEmail={isDisableEmail}
                  handleSaveEmail={handleSaveEmail}
                  handleEditEmail={handleEditEmail}
                  setIsCancel={setIsCancel}
                />
              )
                : activeTab === "Change password" ?
                  (
                    <ChangePassword currentPassword={currentPassword} setCurrentPassword={setCurrentPassword} newPassword={newPassword} setNewPassword={setNewPassword} />
                  )
                  : ("Not found")
              }


            </div>

          </div>

        </div>

      </Base>

    </>
  )
}





export default AccountSettings